export default "__VITE_ASSET__DeDlki3H__"